export const RESET = 'CONTACT_UPDATE_RESET'
export const SET_ERROR = 'CONTACT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CONTACT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CONTACT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CONTACT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CONTACT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CONTACT_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/contact/update/mutation_types.js